import React, { useEffect, useRef, useState } from 'react'
import './AddHoliday.css'
import { useSelector } from 'react-redux';
import profile from '../../../../assets/images/profile.png'
import { useDispatch } from 'react-redux';
import { setAddHolidayFlag, setMonthData } from '../../../../erpStore/actions';
import { Calendar } from "primereact/calendar";
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';


function AddHoliday() {
const selfInfo = useSelector((state) => state.data.selfData)
const dispatch = useDispatch()
const holidayCalRef = useRef(null)
const [ holidayCalFlag, setHolidayCalFlag ] = useState(false)

const months = {
  'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04', 'May': '05', 'Jun': '06',
  'Jul': '07', 'Aug': '08', 'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
};

const onLeaveDate = useSelector((state) => state.data.onLeaveDate)
const parts = onLeaveDate.split(' ');
const day = parts[1].replace(',', '');
const month = months[parts[2]];
const year = parts[3];
const tempOnLeaveDate = `${year}-${month}-${day.padStart(2, '0')}`;
const [holidayDate, setHolidayDate] = useState(tempOnLeaveDate)

const stringHeaders = window.localStorage.getItem('myHeaders');
const storedHeaders = JSON.parse(stringHeaders);

const url = useSelector((state) => state.data.apiUrl)
const [holidayTitle, setHolidayTitle] = useState('')
const [holidayDesc, setHolidayDesc] = useState('')
const [dateErrorFlag, setDateErrorFlag] = useState(false)
const [titleErrorFlag, setTitleErrorFlag] = useState(false)
const [clicked, setClicked] = useState(false)

const monthData = useSelector((state) => state.data.monthData)

useEffect(() => {
  function handleOutsideClick(event) {
    if (holidayCalRef && holidayCalRef.current && !holidayCalRef.current.contains(event.target)) {
      setHolidayCalFlag(false)
    }
  }
  document.addEventListener("mousedown", handleOutsideClick);
  return () => {
    document.removeEventListener("mousedown", handleOutsideClick)
  }
}, [])



const addHoliday = () => {
  
  const obj = monthData[holidayDate]

  if(holidayDate === '' || holidayDate === null){
     toast.error('please select the holiday date', {autoClose: 2000}) 
     setDateErrorFlag(true)
     setClicked(false)
  }

  if(holidayTitle === ''){
    toast.error('add the holiday title', {autoClose: 2000}) 
    setTitleErrorFlag(true)
    setClicked(false)
  }

  if(holidayTitle !== '' && (holidayDate !== '' || holidayDate !== null)){
    setClicked(true)

    axios.post(`${url}holiday/add`, {
      "userId" : selfInfo.userId,
      "holidayDate" : holidayDate,
      "holidayTitle" : holidayTitle,
      "holidayDescription": holidayDesc.trim()
    }, {headers: storedHeaders})
    .then(response => {
      if(response.request.status === 201){
        if(monthData.hasOwnProperty(holidayDate)){
          monthData[holidayDate].holidayData = {
            "holidayDate" : holidayDate,
            "holidayDescription" : holidayDesc.trim(),
            "holidayTitle" : holidayTitle,
            "isHoliday" : "true"
          }
          dispatch(setMonthData(monthData))
      }else{
      }
        toast.success('Holiday Added successfully', {autoClose: 2000})
        dispatch(setAddHolidayFlag(false))
        setClicked(false)
      }
    })
    .catch(error => {
      if(error.response.status === 409){
        toast.error('already holiday added', {autoClose: 2000})
      }else{
        toast.error('Error Occured', {autoClose: 2000})
      }
      setClicked(false)

    })

  }
  
}

  return (
    <div className='new_Task_mainContainer'>
      <div className='newTask_template_Container' id='unLoadHolidayTemplate'>
        <div className='newTask_header'>
          <div className='newTask_header_cross_icon'>
            <svg onClick={() => {
              const unloadElement = document.getElementById('unLoadHolidayTemplate');
              if (unloadElement) {
                unloadElement.classList.add('fade-out');
              }
              setTimeout(function () {
                dispatch(setAddHolidayFlag(false))
              }, 1000)
            }} width="22" height="22" style={{ marginLeft: '15px', cursor: 'pointer'}} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
            </svg>
          </div>
          <div className='newTask_Profile_info'>
            <div className='newTask_userName'>
              <div className='img-holder'>
                <img src={ selfInfo && selfInfo.empImg ? selfInfo.empImg :  profile} alt="" />
              </div>
              <div className='empInfo-name-holder'>
                <p>{selfInfo.empFullName}</p>
              </div>

            </div>
            <div className='newTask_Notification'>
              <svg width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
              </svg>
            </div>
          </div>
        </div>

        <div className='mainDivForHolder'>
          <div className='NewAddTask_heading addHoliday_heading'>
                <p>Add New Holiday</p>
              </div>

              <div className='addHolidaySlot'>
                <label style={{color: 'rgb(38 50 56 / 49%)'}}>*Date of Holiday</label>
                {/* <input type='date' value={projectObj.projectStartDate} onChange={handleStartDate}></input> */}
                <div className='prjStrDateHold'>
                  <div className='prjSatrtDate' onClick={() => {setHolidayCalFlag(true)}}>
                      <p className='prjStrDtePara'>{holidayDate}</p>

                      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.74656 1.93343C2.12713 2.01674 1.77036 2.17297 1.51 2.43355C1.24942 2.69391 1.09292 3.05096 1.00961 3.67038C0.92451 4.30309 0.923529 5.13714 0.923529 6.31108V7.54245C0.923529 8.71638 0.92451 9.55044 1.00961 10.1831C1.09292 10.8026 1.24914 11.1593 1.50973 11.4197C1.77009 11.6803 2.12713 11.8368 2.74656 11.9201C3.37926 12.0052 4.21332 12.0062 5.38725 12.0062H7.84999C9.02393 12.0062 9.85798 12.0052 10.4907 11.9201C11.1101 11.8368 11.4669 11.6806 11.7272 11.42C11.9878 11.1596 12.1443 10.8026 12.2276 10.1831C12.3127 9.55044 12.3137 8.71638 12.3137 7.54245V6.31108C12.3137 5.13714 12.3127 4.30309 12.2276 3.67038C12.1443 3.05096 11.9881 2.69419 11.7275 2.43383C11.4672 2.17325 11.1101 2.01674 10.4907 1.93343C9.85798 1.84834 9.02393 1.84736 7.84999 1.84736H5.38725C4.21332 1.84736 3.37926 1.84834 2.74656 1.93343ZM5.3525 0.923828H7.88474C9.01614 0.923819 9.91238 0.923811 10.6138 1.01815C11.3355 1.11521 11.9197 1.31972 12.3803 1.78052C12.8413 2.24113 13.0458 2.82544 13.1429 3.54728C13.2373 4.24868 13.2372 5.14492 13.2372 6.27632V7.57721C13.2372 8.7086 13.2373 9.60484 13.1429 10.3062C13.0458 11.028 12.8413 11.6123 12.3804 12.0729C11.9198 12.5338 11.3356 12.7383 10.6138 12.8354C9.91238 12.9297 9.01614 12.9297 7.88475 12.9297H5.35249C4.2211 12.9297 3.32486 12.9297 2.62345 12.8354C1.90161 12.7383 1.3173 12.5337 0.856692 12.0727C0.395887 11.6122 0.191385 11.0279 0.094319 10.3062C-1.73397e-05 9.60484 -9.56362e-06 8.7086 1.97977e-07 7.57719V6.27633C-9.56362e-06 5.14493 -1.73397e-05 4.24869 0.094319 3.54728C0.191395 2.82551 0.395928 2.24125 0.856831 1.78066C1.31742 1.31976 1.90168 1.11522 2.62345 1.01815C3.32486 0.923811 4.2211 0.923819 5.3525 0.923828Z" fill="#263238"/>
                          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M3.54094 0C3.79597 0 4.00271 0.206739 4.00271 0.461764V1.38529C4.00271 1.64032 3.79597 1.84706 3.54094 1.84706C3.28592 1.84706 3.07918 1.64032 3.07918 1.38529V0.461764C3.07918 0.206739 3.28592 0 3.54094 0ZM9.6978 0C9.95282 0 10.1596 0.206739 10.1596 0.461764V1.38529C10.1596 1.64032 9.95282 1.84706 9.6978 1.84706C9.44277 1.84706 9.23603 1.64032 9.23603 1.38529V0.461764C9.23603 0.206739 9.44277 0 9.6978 0ZM0.308594 4.46372C0.308594 4.20869 0.515333 4.00196 0.770358 4.00196H12.4684C12.7234 4.00196 12.9301 4.20869 12.9301 4.46372C12.9301 4.71875 12.7234 4.92548 12.4684 4.92548H0.770358C0.515333 4.92548 0.308594 4.71875 0.308594 4.46372Z" fill="#263238"/>
                          <path d="M10.314 9.38898C10.314 9.55227 10.2491 9.70887 10.1337 9.82433C10.0182 9.93979 9.86161 10.0047 9.69832 10.0047C9.53503 10.0047 9.37843 9.93979 9.26297 9.82433C9.1475 9.70887 9.08264 9.55227 9.08264 9.38898C9.08264 9.22569 9.1475 9.06908 9.26297 8.95362C9.37843 8.83816 9.53503 8.77329 9.69832 8.77329C9.86161 8.77329 10.0182 8.83816 10.1337 8.95362C10.2491 9.06908 10.314 9.22569 10.314 9.38898ZM10.314 6.92623C10.314 7.08952 10.2491 7.24612 10.1337 7.36159C10.0182 7.47705 9.86161 7.54192 9.69832 7.54192C9.53503 7.54192 9.37843 7.47705 9.26297 7.36159C9.1475 7.24612 9.08264 7.08952 9.08264 6.92623C9.08264 6.76294 9.1475 6.60634 9.26297 6.49088C9.37843 6.37541 9.53503 6.31055 9.69832 6.31055C9.86161 6.31055 10.0182 6.37541 10.1337 6.49088C10.2491 6.60634 10.314 6.76294 10.314 6.92623ZM7.23558 9.38898C7.23558 9.55227 7.17071 9.70887 7.05525 9.82433C6.93979 9.93979 6.78319 10.0047 6.61989 10.0047C6.45661 10.0047 6.3 9.93979 6.18454 9.82433C6.06908 9.70887 6.00421 9.55227 6.00421 9.38898C6.00421 9.22569 6.06908 9.06908 6.18454 8.95362C6.3 8.83816 6.45661 8.77329 6.61989 8.77329C6.78319 8.77329 6.93979 8.83816 7.05525 8.95362C7.17071 9.06908 7.23558 9.22569 7.23558 9.38898ZM7.23558 6.92623C7.23558 7.08952 7.17071 7.24612 7.05525 7.36159C6.93979 7.47705 6.78319 7.54192 6.61989 7.54192C6.45661 7.54192 6.3 7.47705 6.18454 7.36159C6.06908 7.24612 6.00421 7.08952 6.00421 6.92623C6.00421 6.76294 6.06908 6.60634 6.18454 6.49088C6.3 6.37541 6.45661 6.31055 6.61989 6.31055C6.78319 6.31055 6.93979 6.37541 7.05525 6.49088C7.17071 6.60634 7.23558 6.76294 7.23558 6.92623ZM4.15715 9.38898C4.15715 9.55227 4.09229 9.70887 3.97682 9.82433C3.86136 9.93979 3.70476 10.0047 3.54147 10.0047C3.37818 10.0047 3.22157 9.93979 3.10611 9.82433C2.99065 9.70887 2.92578 9.55227 2.92578 9.38898C2.92578 9.22569 2.99065 9.06908 3.10611 8.95362C3.22157 8.83816 3.37818 8.77329 3.54147 8.77329C3.70476 8.77329 3.86136 8.83816 3.97682 8.95362C4.09229 9.06908 4.15715 9.22569 4.15715 9.38898ZM4.15715 6.92623C4.15715 7.08952 4.09229 7.24612 3.97682 7.36159C3.86136 7.47705 3.70476 7.54192 3.54147 7.54192C3.37818 7.54192 3.22157 7.47705 3.10611 7.36159C2.99065 7.24612 2.92578 7.08952 2.92578 6.92623C2.92578 6.76294 2.99065 6.60634 3.10611 6.49088C3.22157 6.37541 3.37818 6.31055 3.54147 6.31055C3.70476 6.31055 3.86136 6.37541 3.97682 6.49088C4.09229 6.60634 4.15715 6.76294 4.15715 6.92623Z" fill="#FF8402"/>
                      </svg>

                  </div>

                    { holidayCalFlag && 
                      <div className='addprfEndCld addHolidayCld' ref={holidayCalRef}>
                          <Calendar value={moment(holidayDate)._d} inline onChange={(e) => {
                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                            setHolidayDate(formattedDate)
                            setHolidayCalFlag(false)
                            setDateErrorFlag(false)
                          }}unstyled={false}  />
                      </div>
                      }
                </div>
                { dateErrorFlag  ? <p style={{fontSize: '12px', color: 'red'}}>Please Select holiday date</p> : null}
            </div>

            <div className='holidayTilteHld'>
                <label  style={{color: 'rgb(38 50 56 / 49%)'}}>*Holiday Title</label>
                <div className='holidayInptFieldDiv'>
                  <input className='holidayInptField' value={holidayTitle} maxLength={30} onChange={(e) => {
                    setHolidayTitle(e.target.value)
                    setTitleErrorFlag(false)
                  }} type='text' placeholder='Enter holiday title'/>
                  <div className='countTitleHol' style={{color: '#FF8402'}}>{`${holidayTitle?.length}/30`}</div>
                </div>
                { titleErrorFlag ? <p style={{fontSize: '12px', color: 'red'}}>Please Select holiday title </p> : null}
            </div>

            <div className='holidayDecriptionDiv'>
              <label  style={{color: 'rgb(38 50 56 / 49%)'}}>Holiday Description</label>  
              <textarea className='holidayDescpTxtArea' onChange={(e) => {
                setHolidayDesc(e.target.value)
              }} minLength={150}></textarea>   
            </div>
        </div>
        
        <div className='AddTaskButton'>
          <button id='AddTaskBtn'onClick={ clicked === false ? () => {
            setClicked(true)
            addHoliday()
          } : null}>{ clicked ? <div className='taskLoader'></div> : 'Add Holiday'}</button>
          <button id='CancelTaskBtn' onClick={() => {
              const unloadElement = document.getElementById('unLoadHolidayTemplate');
              if (unloadElement) {
                unloadElement.classList.add('fade-out');
              }
              setTimeout(function () {
                dispatch(setAddHolidayFlag(false))
              }, 1000)
            }}> Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default AddHoliday